// Sonnenauf-/-untergang (NOAA-Näherung, ±2 min) – Ortszeit Kanaren (Atlantic/Canary)
const RAD = Math.PI / 180;
const ISLAND_CENTER = {
  tenerife: [28.29, -16.63], "gran-canaria": [27.96, -15.6], fuerteventura: [28.36, -14.03], lanzarote: [29.03, -13.63],
  "la-palma": [28.67, -17.86], "la-gomera": [28.11, -17.24], "el-hierro": [27.74, -17.98], "la-graciosa": [29.23, -13.5],
};

const sunEvent = (lat, lng, date, rising) => {
  const dayOfYear = Math.floor((Date.UTC(date.getUTCFullYear(), date.getUTCMonth(), date.getUTCDate()) - Date.UTC(date.getUTCFullYear(), 0, 0)) / 86400000);
  const lngHour = lng / 15;
  const t = dayOfYear + ((rising ? 6 : 18) - lngHour) / 24;
  const M = 0.9856 * t - 3.289;
  let L = M + 1.916 * Math.sin(M * RAD) + 0.02 * Math.sin(2 * M * RAD) + 282.634;
  L = ((L % 360) + 360) % 360;
  let RA = Math.atan(0.91764 * Math.tan(L * RAD)) / RAD;
  RA = ((RA % 360) + 360) % 360;
  RA = (RA + Math.floor(L / 90) * 90 - Math.floor(RA / 90) * 90) / 15;
  const sinDec = 0.39782 * Math.sin(L * RAD), cosDec = Math.cos(Math.asin(sinDec));
  const cosH = (Math.cos(90.833 * RAD) - sinDec * Math.sin(lat * RAD)) / (cosDec * Math.cos(lat * RAD));
  if (cosH > 1 || cosH < -1) return null;
  const H = (rising ? 360 - Math.acos(cosH) / RAD : Math.acos(cosH) / RAD) / 15;
  const T = H + RA - 0.06571 * t - 6.622;
  const UT = (((T - lngHour) % 24) + 24) % 24;
  return new Date(Date.UTC(date.getUTCFullYear(), date.getUTCMonth(), date.getUTCDate(), 0, Math.round(UT * 60)));
};

const fmtTime = (d) => d ? new Intl.DateTimeFormat("de-DE", { hour: "2-digit", minute: "2-digit", timeZone: "Atlantic/Canary" }).format(d) : "–";

/** Sonnenaufgang/-untergang zur Monatsmitte (15.) für alle 12 Monate, als "HH:MM" Ortszeit. */
export const monthlySunTimes = (island, year = new Date().getFullYear()) => {
  const c = ISLAND_CENTER[island];
  if (!c) return null;
  return Array.from({ length: 12 }, (_, m) => {
    const d = new Date(Date.UTC(year, m, 15));
    return { sunrise: fmtTime(sunEvent(c[0], c[1], d, true)), sunset: fmtTime(sunEvent(c[0], c[1], d, false)) };
  });
};
